export const TEXTS = {
    PAYMENT_OFFERS_PAGE_TITLE: "Extra cashback & discounts",
};
